import { render, staticRenderFns } from "./about_page.vue?vue&type=template&id=4af5c664&scoped=true"
import script from "./about_page.vue?vue&type=script&lang=js"
export * from "./about_page.vue?vue&type=script&lang=js"
import style0 from "./about_page.vue?vue&type=style&index=0&id=4af5c664&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af5c664",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4af5c664')) {
      api.createRecord('4af5c664', component.options)
    } else {
      api.reload('4af5c664', component.options)
    }
    module.hot.accept("./about_page.vue?vue&type=template&id=4af5c664&scoped=true", function () {
      api.rerender('4af5c664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/about_page.vue"
export default component.exports